import { X } from "lucide-react";
import { useEffect } from "react";

export default function Modal({ open, onClose, title, children, size = "md" }) {
  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onEsc);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onEsc); document.body.style.overflow = ""; };
  }, [open, onClose]);

  if (!open) return null;

  const widths = { sm: "max-w-md", md: "max-w-xl", lg: "max-w-3xl" };

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4" data-testid="admin-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative w-full ${widths[size]} max-h-[95vh] sm:max-h-[90vh] overflow-y-auto overflow-x-hidden rounded-t-2xl sm:rounded-2xl bg-slate-900 border border-white/10 shadow-2xl`}>
        <div className="sticky top-0 flex items-center justify-between px-4 sm:px-6 py-3.5 sm:py-4 border-b border-white/10 bg-slate-900 z-10 gap-3">
          <h3 className="text-base sm:text-lg font-bold text-white font-[Outfit] truncate min-w-0">{title}</h3>
          <button onClick={onClose} data-testid="modal-close"
            className="shrink-0 w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center text-slate-300 transition">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-4 sm:p-6">{children}</div>
      </div>
    </div>
  );
}

export const Field = ({ label, children, hint }) => (
  <div className="space-y-1.5">
    <label className="block text-[11px] uppercase tracking-[0.15em] font-bold text-slate-300">{label}</label>
    {children}
    {hint && <p className="text-[11px] text-slate-500">{hint}</p>}
  </div>
);

export const Input = (props) => (
  <input {...props}
    className={`w-full px-3 py-2.5 rounded-xl bg-slate-800/60 border border-white/10 text-white placeholder-slate-500 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 transition ${props.className || ""}`} />
);

export const Textarea = (props) => (
  <textarea {...props}
    className={`w-full px-3 py-2.5 rounded-xl bg-slate-800/60 border border-white/10 text-white placeholder-slate-500 focus:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 transition ${props.className || ""}`} />
);

export const Btn = ({ variant = "primary", className = "", ...rest }) => {
  const styles = {
    primary: "bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-400 hover:to-emerald-500 text-white shadow-lg shadow-emerald-500/30",
    secondary: "bg-white/5 hover:bg-white/10 text-white border border-white/10",
    danger: "bg-red-500/10 hover:bg-red-500/20 text-red-300 border border-red-500/30",
    ghost: "text-slate-400 hover:text-white hover:bg-white/5",
  };
  return <button {...rest} className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl font-semibold text-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed ${styles[variant]} ${className}`} />;
};
